import apiService from './api';

const walletService = {
  // Récupérer tous les wallets ou filtrer par type
  async getWallets(walletType = null) {
    const params = walletType ? { type: walletType } : {};
    const response = await apiService.get('/wallets', params);
    return response.data || response; // apiService returns the full data object or the array depending on backend structure
  },

  // Récupérer un wallet spécifique par asset et type
  async getWallet(asset, walletType = 'spot') {
    const response = await apiService.get(`/wallets/${asset}/${walletType}`);
    return response.data || response;
  },

  // Récupérer les wallets par type
  async getWalletsByType(walletType) {
    const response = await apiService.get(`/wallets/type/${walletType}`);
    return response.data || response;
  },

  // Récupérer le solde total par type de wallet
  async getTotalBalanceByType(walletType) {
    const response = await apiService.get(`/wallets/total/${walletType}`);
    return response.data || response;
  },

  // Créer une adresse de dépôt avec spécification du type
  async createDepositAddress(chain, asset, walletType = 'spot') {
    const response = await apiService.post('/wallets/deposit-address', { 
      chain, 
      asset, 
      wallet_type: walletType 
    });
    return response.data || response;
  },

  // Demande de retrait avec spécification du type
  async requestWithdrawal(withdrawalData) {
    const response = await apiService.post('/wallets/withdraw', {
      ...withdrawalData,
      wallet_type: withdrawalData.wallet_type || 'spot'
    });
    return response.data || response;
  },

  // Historique des dépôts avec filtrage par type
  async getDepositHistory(walletType = null) {
    const params = walletType ? { type: walletType } : {};
    const response = await apiService.get('/wallets/deposits/history', params);
    return response.data || response;
  },

  // Historique des retraits avec filtrage par type
  async getWithdrawalHistory(walletType = null) {
    const params = walletType ? { type: walletType } : {};
    const response = await apiService.get('/wallets/withdrawals/history', params);
    return response.data || response;
  },

  // Transfert entre wallets
  async transferFunds(transferData) {
    const response = await apiService.post('/wallets/transfer', transferData);
    return response.data || response;
  },

  // Récupérer les statistiques de wallet
  async getWalletStats(walletType = null) {
    const params = walletType ? { type: walletType } : {};
    const response = await apiService.get('/wallets/stats', params);
    return response.data || response;
  },

  // ─── Nouveau système de dépôt Binance ──────────────────────────────────────

  async getDepositAddress(coin, network) {
    const response = await apiService.get('/deposits/address', { coin, network });
    return response.data || response;
  },

  async getSupportedCoins() {
    const response = await apiService.get('/deposits/supported');
    return response.data || response;
  },

  async notifyDeposit(depositData) {
    const response = await apiService.post('/deposits/notify', depositData);
    return response.data || response;
  },

  async getMyDepositHistory(page = 1, limit = 20) {
    const response = await apiService.get('/deposits/history', { page, limit });
    return response;
  }
};

export default walletService;
